import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  counts: {
    'export': 0
  },
};

export const NotificationsStore = createSlice({
  name: 'NotificationsStore',
  initialState,
  reducers: {
    changeCount: (state, action) => {
      const { key, value } = action.payload;
      state.counts[key] = value;
    },
  },
});

export const { changeCount } = NotificationsStore.actions;
export default NotificationsStore.reducer;

